import { CfSliderCardsProps } from "./schema";
import React from "react";
import SliderCards, { SliderCardsProps } from "..";

export const convertCfSliderCardsProps = ({
  children,
  theme,
}: CfSliderCardsProps): SliderCardsProps => ({
  children,
  theme,
});

const CfSliderCards = (props: CfSliderCardsProps) => {
  return <SliderCards {...convertCfSliderCardsProps(props)} />;
};

export default CfSliderCards;
